var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container, ( _obj = {}, _obj[_vm.$style.padding] = !_vm.$slots.activator, _obj )]},[_vm._t("activator",function(){
var _obj;
return [_c('i',{staticClass:"far fa-question-circle",class:[( _obj = {}, _obj[_vm.$style.icon_attention] = _vm.isAttention, _obj ), _vm.$style.icon]})]}),(_vm.$slots.default)?_c('div',{class:[
      _vm.$style.tooltip,
      _vm.isAttention ? _vm.$style.attention : '',
      _vm.$kindStyle[_vm.placement] ],style:({ minWidth: _vm.minWidth })},[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }